<template>
  <div>
    <edit-form
      :disabled="isDisableEditForm"
      :reportBudgetNo="reportBudgetNo"
      ref="editForm"
      :form="formData"
      @updateBudgetType="updateBudgetType"
    />
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!isDisableEditForm">
      <el-button type="primary" size="small" @click="save()">{{
        $l('INDEX.btn_save') || '保存'
      }}</el-button>
    </div>
    <BudgetQuarter
      ref="budgetQuarter"
      :disabled="isDisableEditForm"
      :tableData="formData.budgetQuarterList"
      @reload="getData"
      @updateTotBudget="updateTotBudget"
      :reportBudgetCode="code"
    />
  </div>
</template>

<script>
import EditForm from '../components/detail-form'
import BudgetQuarter from '../components/detail-form/budget-quarter.vue'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  name: 'financial-finSet-budget-detail',
  components: {
    EditForm,
    BudgetQuarter,
  },
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      code: '',
      formData: { totBudget: 0, depCode: '' },
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    pageType() {
      return this.params.pageType
    },
    reportBudgetNo() {
      return this.query.reportBudgetNo
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.code = this.params.code || ''
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.code) {
        return
      }
      this.$api
        .orderBudgetDetailApi({
          reportBudgetCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      // 获取主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 合成订单提交参数
      let params = {
        ...getFormData,
      }
      this.loadingOpen()
      const res = await this.$api.orderBudgetSaveApi(params)
      this.loadingClose()
      if (this.code) {
        await this.saveOkQuestion()
      } else {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_save_ok') || '保存成功！',
          type: 'success',
        })
        this.code = res?.body?.reportBudgetCode
        // await this.closeCurPage()
        this.$router.replace({
          name: 'financial-finSet-budget-detail',
          params: { code: res?.body?.reportBudgetCode, pageType: 'edit' },
          query: { reportBudgetNo: res?.body?.reportBudgetNo },
        })
      }
    },
    async saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    updateTotBudget(val) {
      this.$refs.editForm.updateTotBudget(val)
    },
    updateBudgetType(val) {
      this.$refs.budgetQuarter.updateBudgetType(val)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
